import { render, staticRenderFns } from "./GxLoading.vue?vue&type=template&id=760f5bb2&scoped=true"
import script from "./GxLoading.vue?vue&type=script&lang=js"
export * from "./GxLoading.vue?vue&type=script&lang=js"
import style0 from "./GxLoading.vue?vue&type=style&index=0&id=760f5bb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "760f5bb2",
  null
  
)

export default component.exports